const W = 560;
const H = 230;

const scale = (vals, half) => {
  const m = Math.max(1e-9, ...vals.map((v) => Math.abs(v)));
  return (v) => (v / m) * half;
};

export default function MullionModelChart({ m }) {
  const d = m.diagram || [];
  if (!d.length) return null;
  const L = d[d.length - 1][0] || 1;
  const yPx = (y) => 18 + (1 - y / L) * (H - 36);
  const sm = scale(d.map((p) => p[1]), 90);
  const sv = scale(d.map((p) => p[2]), 60);
  const base = 150;
  const vx = 400;
  const supports = Array.from({ length: m.floors_per_unit + 1 }, (_, i) => i * m.span_mm - (m.stack_offset_mm || 0)).filter((y) => y >= -1 && y <= L + 1);
  const mPath = `M${base},${yPx(d[0][0])} ` + d.map((p) => `L${base + sm(p[1])},${yPx(p[0])}`).join(" ") + ` L${base},${yPx(L)} Z`;
  const vPath = d.map((p, i) => `${i ? "L" : "M"}${vx + sv(p[2])},${yPx(p[0])}`).join(" ");
  return (
    <div className="rounded-lg border border-zinc-800 bg-[#121215] p-4" data-testid="mullion-model-chart">
      <div className="mb-2 flex flex-wrap items-baseline justify-between gap-2">
        <span className="font-mono text-[11px] uppercase tracking-wider text-zinc-400">Mullion static model · {m.label}</span>
        <span className="font-mono text-[10px] text-zinc-500" data-testid="mullion-model-values">
          M+ {m.M_pos_kNm} · M− {m.M_neg_kNm} kNm · V {m.V_kN} kN · R {m.R_wind_kN} kN · Δ {m.defl_mm} mm{m.floors_per_unit > 1 ? ` · stack joint +${m.stack_offset_mm} mm` : ""}
        </span>
      </div>
      <svg viewBox={`0 0 ${W} ${H}`} className="h-56 w-full">
        <text x={base} y={12} textAnchor="middle" className="fill-zinc-500 font-mono text-[9px]">BENDING MOMENT</text>
        <text x={vx} y={12} textAnchor="middle" className="fill-zinc-500 font-mono text-[9px]">DEFLECTED SHAPE</text>
        <path d={mPath} fill="rgba(56,189,248,0.18)" stroke="#38bdf8" strokeWidth="1.2" />
        {[base, vx].map((x) => <line key={x} x1={x} x2={x} y1={yPx(0)} y2={yPx(L)} stroke="#71717a" strokeWidth="2" />)}
        <path d={vPath} fill="none" stroke="#f59e0b" strokeWidth="1.6" />
        {supports.map((y) => [base, vx].map((x) => <path key={`${x}-${y}`} d={`M${x - 14},${yPx(y)} l-8,-6 v12 z`} fill="#a1a1aa" />))}
        {m.floors_per_unit > 1 && [0, L].map((y) => [base, vx].map((x) => <circle key={`h${x}-${y}`} cx={x} cy={yPx(y)} r="3.5" fill="#0c0c0f" stroke="#f43f5e" strokeWidth="1.5" />))}
      </svg>
      <div className="flex gap-4 font-mono text-[10px] text-zinc-500"><span className="text-zinc-400">▶ bracket</span>{m.floors_per_unit > 1 && <span className="text-rose-400">○ stack joint (hinge)</span>}<span>one interior mullion unit · {m.unit_length_mm} mm</span></div>
    </div>
  );
}
